import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import moment from 'moment'
import PlayerService from 'src/service/PlayerService'
const FixturePlayerStatsTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByFixture(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CFormSelect
              aria-label="Select player"
              name="player"
              className={'form-control'}
              onChange={handlePlayer}
              id="player"
            >
              <option value={0}>Select Player</option>
              {props.playerList &&
                props.playerList.map((item, key) => (
                  <option value={item?.id} key={key}>
                    {item?.full_name}
                  </option>
                ))}
            </CFormSelect>
            <CTable className="main-table table innertable">
              <CTableHead color="dark">
                <tr>
                  <th>Date</th>
                  <th>Team</th>
                  <th>FP</th>
                  <th>GO</th>
                  <th>GKS</th>
                  <th>OG</th>
                  <th>AST</th>
                  <th>PS</th>
                  <th>PM</th>
                  <th>GCD</th>
                  <th>YCD</th>
                  <th>RCD</th>
                  <th>CST</th>
                  <th>P60</th>
                  <th>P60PLUS</th>
                </tr>
              </CTableHead>
              <CTableBody>
                {statsData &&
                  statsData.map((item, key) => (
                    <tr key={key}>
                      <td> {moment(item.fixture.start_date).format('D.MM.YYYY')}</td>
                      <td>{item?.teamName}</td>
                      <td>{item.fantasy_points}</td>
                      <td>{item?.go}</td>
                      <td>{item?.gks}</td>
                      <td>{item?.og}</td>
                      <td>{item?.ast}</td>
                      <td>{item?.pi}</td>
                      <td>{item?.tw}</td>
                      <td>{item?.ps}</td>
                      <td>{item?.pm}</td>
                      <td>{item?.gcd}</td>
                      <td>{item?.ycd}</td>
                      <td>{item?.rcd}</td>
                      <td>{item?.cst}</td>
                      <td>{item?.p60}</td>
                      <td>{item?.p60plus}</td>
                    </tr>
                  ))}
                {statsData.length === 0 && (
                  <tr>
                    <td colSpan={15}>No record yet available.</td>
                  </tr>
                )}
              </CTableBody>
            </CTable>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default FixturePlayerStatsTab
